import { keyMirror } from '@poinz/utils';
import { PagableParams, ScaledImage } from '../../../types';
import { GiftCard } from './giftCard';
import { BusinessProfile } from 'partnerClient/backend/types';

export const EGIFT_STATUS = keyMirror({
  COMPLETED: null,
  FAILED: null,
  PENDING: null
});

export type EgiftStatus = keyof typeof EGIFT_STATUS;

export interface Egift {
  id: number;
  status: EgiftStatus;
  giftCard: GiftCard;
  userId: number;
  referenceNumber: string;
  amount: number;
  created: string;
  errorDescription: string;
  purchaserId: number;
  recipientEmail: string;
  recipientId: number;
  name: string;
  picture?: ScaledImage;
  expiryDate?: string;
  redeemed: boolean;
  businessProfile?: BusinessProfile;
  description?: string;
  termsAndConditionsWeb?: string;
}

export interface EgiftPayload {
  giftCardId: number;
  userId: string;
  amount: number;
}

export interface PaginatedEgiftParams extends PagableParams {
  eGiftId: number;
  status: EgiftStatus;
}

export enum IEgiftBarcodeType {
  EAN13 = 'EAN13',
  EAN8 = 'EAN8',
  CODE128 = 'CODE128',
  ITF = 'ITF',
  CODE39 = 'CODE39',
  QRCODE = 'QRCODE',
  AZTEC = 'AZTEC',
  PDF417 = 'PDF417',
  UPCA = 'UPCA',
  DATAMATRIX = 'DATAMATRIX'
}

export enum IEgiftSource {
  BHN = 'BHN',
  EGUMA = 'EGUMA',
  OFFERZ = 'OFFERZ'
}

export interface IEgiftRedemption {
  accountNumber?: number;
  barCodeType: IEgiftBarcodeType;
  barCodeValue?: string | number;
  expiryDate: Date;
  pdfUrl: string;
  pin: string;
  securityCode: string;
  serialNumber: string;
  source: string;
}
